import React from 'react'
import Magrays from '../images/magrays2.png'
import Magstrics from '../images/magstrics3.png'
import AnimatedElement from '../components/AnimatedElement'
import RevealText from '../components/TextReveal2'
function Products2() {
    return (
        <div className='py-10 px-[15%] max-sm:px-4 bg-gray-200'>
            <RevealText text='Our Products ' css='text-[3rem] max-sm:text-[2rem] font-bold poppins text-[#425472] uppercase ' />
           
            <div className='mt-10'>
                <div>
                    <ProductStyle name='Magrays' img={Magrays} description='This device is used to detect the feeble magnetic field present during the machining process in industrial, automotive and defence applications' />
                    <ProductStyle name='Magstrics' img={Magstrics} description='This device is used for performing underground mild steel pipe inspection' link=' https://youtu.be/PEuJmGpEp6U?si=a16TFpnUtThNceDA' />
                    
                </div>
               
            </div>

        </div>
    )
}
function ProductStyle({ name, img, width = 500, height, css = '', description, link = '' }) {
    return (
        <div className=' text-white my-10 max-sm:my-5 '>
            <AnimatedElement direction='from-left'>

                <h1 className='text-[2.5rem] max-sm:text-[1.8rem] font-bold text-left bg-gradient-to-r from-[#6d222e] to-[#505da0] w-fit  text-transparent bg-clip-text'>{name}</h1>
            </AnimatedElement>
            <div className='flex  gap-10 flex-col  '>


                <h1 className=' text-left text-black text-[18px] flex-[1]'>
                    <AnimatedElement direction='from-left'>

                        {description}
                    </AnimatedElement>
                    {
                        link === '' ? '' :
                            <a className='text-blue-900 underline' href={link}>Click here for video description</a>
                    }
                </h1>

                <div className=' flex-1 flex items-center self-center w-[400px] h-[400px] max-sm:w-fit justify-center'>
                    <AnimatedElement direction='from-right'>

                        <img src={img} width={width} className={`${css} radial-gradient rounded-3xl `} />
                    </AnimatedElement>
                </div>
            </div>
        </div>
    )
}

export default Products2